import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import {
  selectPrivacyCenterPages,
  selectRequiredPrivacyCenter,
} from '../containers/App/selectors';
import NotFound from '../containers/NotFound';

/**
 * Redirect to the first enabled page
 */
export const HomePage: React.FC = () => {
  const location = useLocation();
  const { locale } = useIntl();

  const { locales } = useSelector(selectRequiredPrivacyCenter);
  const links = useSelector(selectPrivacyCenterPages);
  const firstLink = links[0];

  // nothing is enabled - misconfiguration
  if (!firstLink) {
    return <NotFound />;
  }

  return (
    <Navigate
      to={{
        ...location,
        pathname:
          locales.length > 1 ? `${firstLink.href}/${locale}/` : firstLink.href,
      }}
      replace
    />
  );
};
